import React from 'react';

function Home() {
  return (
    <div className="page">
      <h2>Home</h2>
      <p>Welcome to the home page.</p>
    </div>
  );
}

export default Home;
